// Module
var code = "<!-- ko with: Portlet--> <!-- ko template: {name: GetTemplateName(), afterRender: AfterRender} --> <!-- /ko --> <!-- /ko -->";
// Exports
export default code;